module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "minWidth": '80%',
      "maxWidth": '80%'
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.zones.length > 0) ? _c('div', [_c('p', {
    staticClass: "ff-light title-modal"
  }, [_vm._v(_vm._s(_vm.$t("menuHeader.selectZone")))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between flex-wrap modalFlex"
  }, _vm._l((_vm.zones), function(zone, index) {
    return (!_vm.isDisabledZone(zone.id)) ? _c('div', {
      key: zone.id,
      staticClass: "brandWrap flexContainer jc-c fd-c pointer",
      on: {
        "click": function($event) {
          _vm.saveZone(zone);
        }
      }
    }, [_c('div', {
      staticClass: "brandLogo",
      class: [_vm.selectZone === zone.name.toLowerCase() ? '_selectedZone' : '', ''],
      attrs: {
        "id": 'hover' + index
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("trimModal")(zone.name)))])])]) : _vm._e()
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0918a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalZone.vue
// module id = 3330
// module chunks = 0